var _rect, _rect2, _rect3, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAyurvedaBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 335,
    height: 74,
    viewBox: "0 0 335 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19491_33012)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 335,
    height: 74,
    fill: "url(#paint0_linear_19491_33012)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_19491_33012",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 333,
    height: 134
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 333,
    height: 134,
    rx: 11,
    fill: "#EEFAFE"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 332,
    height: 133,
    rx: 10.5,
    stroke: "url(#paint1_linear_19491_33012)",
    strokeOpacity: 0.2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_19491_33012)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: -6,
    r: 113.8,
    fill: "#006B9B",
    fillOpacity: 0.05,
    stroke: "url(#paint2_linear_19491_33012)",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: -6,
    r: 101.9,
    stroke: "url(#paint3_linear_19491_33012)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.9 -6C111.9 44.755 70.755 85.9 20 85.9C-30.755 85.9 -71.9 44.755 -71.9 -6C-71.9 -56.755 -30.755 -97.9 20 -97.9C70.755 -97.9 111.9 -56.755 111.9 -6Z",
    stroke: "url(#paint4_linear_19491_33012)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.9 -6C101.9 39.2321 65.2321 75.9 20 75.9C-25.2321 75.9 -61.9 39.2321 -61.9 -6C-61.9 -51.2321 -25.2321 -87.9 20 -87.9C65.2321 -87.9 101.9 -51.2321 101.9 -6Z",
    stroke: "url(#paint5_linear_19491_33012)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9 -6C90.9 33.157 59.157 64.9 20 64.9C-19.157 64.9 -50.9 33.157 -50.9 -6C-50.9 -45.157 -19.157 -76.9 20 -76.9C59.157 -76.9 90.9 -45.157 90.9 -6Z",
    stroke: "url(#paint6_linear_19491_33012)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9 -6C80.9 27.6341 53.6341 54.9 20 54.9C-13.6341 54.9 -40.9 27.6341 -40.9 -6C-40.9 -39.6341 -13.6341 -66.9 20 -66.9C53.6341 -66.9 80.9 -39.6341 80.9 -6Z",
    stroke: "url(#paint7_linear_19491_33012)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9 -6C70.9 22.1113 48.1113 44.9 20 44.9C-8.11129 44.9 -30.9 22.1113 -30.9 -6C-30.9 -34.1113 -8.11129 -56.9 20 -56.9C48.1113 -56.9 70.9 -34.1113 70.9 -6Z",
    stroke: "url(#paint8_linear_19491_33012)",
    strokeWidth: 0.2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M292.041 85.8919H260.96C250.659 85.8804 240.784 81.7835 233.5 74.4999C226.217 67.2164 222.12 57.3411 222.108 47.0406V28.3919C222.108 27.9798 222.272 27.5845 222.564 27.2931C222.855 27.0016 223.25 26.8379 223.662 26.8379H329.338C329.75 26.8379 330.146 27.0016 330.437 27.2931C330.728 27.5845 330.892 27.9798 330.892 28.3919V47.0406C330.881 57.3411 326.784 67.2164 319.5 74.4999C312.217 81.7835 302.341 85.8804 292.041 85.8919ZM225.217 29.946V47.0406C225.227 56.517 228.996 65.6022 235.697 72.3031C242.398 79.0039 251.483 82.7731 260.96 82.7838H292.041C301.517 82.7731 310.602 79.0039 317.303 72.3031C324.004 65.6022 327.773 56.517 327.784 47.0406V29.946H225.217Z",
    fill: "#3A2CA0",
    fillOpacity: 0.08
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M292.041 86.8919H292.042C302.607 86.8801 312.736 82.6779 320.207 75.207C327.678 67.7362 331.88 57.607 331.892 47.0417V47.0406V28.3919C331.892 27.7146 331.623 27.0649 331.144 26.586C330.665 26.107 330.016 25.8379 329.338 25.8379H223.662C222.985 25.8379 222.335 26.107 221.856 26.586C221.377 27.0649 221.108 27.7146 221.108 28.3919L221.108 47.0406L221.108 47.0417C221.12 57.607 225.323 67.7362 232.793 75.207C240.264 82.6779 250.393 86.8801 260.959 86.8919H260.96H292.041ZM236.404 71.596C229.891 65.0826 226.227 56.2516 226.217 47.0403V30.946H326.784V47.0395C326.774 56.2511 323.11 65.0824 316.596 71.596C310.083 78.1096 301.251 81.7734 292.04 81.7838H260.961C251.749 81.7734 242.918 78.1096 236.404 71.596Z",
    stroke: "#3A2CA0",
    strokeOpacity: 0.08,
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M279.903 29.3334L277.432 27.4499L298.435 -0.0801563C300.883 -3.44213 302.499 -7.33712 303.149 -11.445C303.53 -13.524 304.378 -15.4895 305.629 -17.1936C306.88 -18.8978 308.5 -20.2964 310.369 -21.2842C312.238 -22.272 314.306 -22.8233 316.419 -22.8968C318.531 -22.9703 320.633 -22.564 322.566 -21.7084C324.499 -20.8529 326.213 -19.5703 327.579 -17.9572C328.945 -16.344 329.927 -14.4423 330.453 -12.3948C330.978 -10.3473 331.032 -8.20733 330.612 -6.13578C330.191 -4.06424 329.307 -2.11497 328.024 -0.434483C326.734 1.26473 325.069 2.64278 323.159 3.59207C319.188 5.45469 315.698 8.20397 312.958 11.6281L299.45 29.3334L296.979 27.4499L310.487 9.74302C313.515 5.9392 317.377 2.88239 321.774 0.80876C323.258 0.0711803 324.551 -0.999456 325.553 -2.31955C326.551 -3.62638 327.239 -5.14226 327.566 -6.75326C327.893 -8.36426 327.851 -10.0285 327.443 -11.6209C327.035 -13.2133 326.271 -14.6925 325.209 -15.9472C324.147 -17.202 322.814 -18.1998 321.311 -18.8655C319.808 -19.5313 318.174 -19.8477 316.531 -19.7911C314.888 -19.7344 313.279 -19.3061 311.825 -18.5384C310.372 -17.7707 309.111 -16.6835 308.138 -15.3586C307.165 -14.0336 306.505 -12.5054 306.207 -10.8886C305.47 -6.29727 303.654 -1.94663 300.906 1.80491L279.903 29.3334ZM286.542 60.6507C284.097 60.5692 281.687 60.0382 279.434 59.0842C279.097 58.9535 278.816 58.7096 278.64 58.3942C276.231 54.0833 275.911 50.1018 277.687 46.5601C282.385 37.1969 300.396 34.7213 301.153 34.6219C301.455 34.5823 301.762 34.6322 302.035 34.7654C302.309 34.8985 302.537 35.109 302.692 35.3708C302.847 35.6326 302.922 35.9341 302.907 36.238C302.893 36.5419 302.789 36.8348 302.609 37.0804C300.61 40.2428 299.131 43.7058 298.23 47.3371C296.584 52.6536 295.032 57.6747 290.75 59.7431C289.435 60.3614 287.996 60.6718 286.542 60.6507ZM281.089 56.3879C284.707 57.7182 287.434 57.9032 289.406 56.9474C292.469 55.4695 293.829 51.0746 295.268 46.4234C296.048 43.6418 297.049 40.9274 298.264 38.3065C293.081 39.4192 283.345 42.2212 280.464 47.9572C279.222 50.4313 279.426 53.1928 281.089 56.3879Z",
    fill: "#3A2CA0",
    fillOpacity: 0.08
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M288.97 56.0475L288.972 56.0468C290.202 55.4531 291.18 54.2277 292.046 52.4397C292.908 50.6596 293.585 48.4811 294.309 46.1406C294.92 43.96 295.666 41.8201 296.542 39.7329C294.243 40.3073 291.489 41.1444 288.913 42.3093C285.526 43.8412 282.639 45.855 281.358 48.4058L288.97 56.0475ZM288.97 56.0475C287.429 56.7943 285.144 56.756 281.802 55.5816M288.97 56.0475L281.802 55.5816M281.802 55.5816C280.406 52.7366 280.343 50.4289 281.358 48.4061L281.802 55.5816ZM279.297 30.1287L280.092 30.7347L280.698 29.94L301.701 2.41148L301.707 2.40368L301.713 2.39577C304.552 -1.4804 306.43 -5.97507 307.192 -10.7185C307.464 -12.1826 308.062 -13.5665 308.944 -14.7666C309.828 -15.9698 310.972 -16.957 312.292 -17.6542C313.612 -18.3513 315.073 -18.7402 316.565 -18.7916C318.057 -18.8431 319.541 -18.5557 320.906 -17.9512C322.271 -17.3466 323.481 -16.4406 324.446 -15.3012C325.41 -14.1618 326.104 -12.8186 326.474 -11.3725L327.443 -11.6209L326.474 -11.3725C326.845 -9.92651 326.883 -8.41527 326.586 -6.95236C326.289 -5.48944 325.664 -4.11292 324.758 -2.92622L324.757 -2.92411C323.85 -1.72945 322.68 -0.760035 321.338 -0.091198C316.806 2.04774 312.826 5.19925 309.704 9.12022L309.698 9.12829L309.692 9.13649L296.184 26.8434L295.577 27.6388L296.373 28.2452L298.844 30.1287L299.639 30.7347L300.245 29.94L313.746 12.244C316.389 8.94353 319.755 6.29338 323.583 4.4974L323.593 4.49262L323.604 4.48762C325.652 3.46993 327.437 1.99267 328.82 0.171148C330.194 -1.62926 331.141 -3.71755 331.592 -5.9368C332.043 -8.15646 331.984 -10.4494 331.421 -12.6433C330.858 -14.8372 329.806 -16.8749 328.342 -18.6034L327.579 -17.9572L328.342 -18.6034C326.878 -20.3319 325.042 -21.7062 322.971 -22.6229C320.9 -23.5396 318.648 -23.975 316.384 -23.8962C314.12 -23.8175 311.904 -23.2267 309.902 -22.1683C307.899 -21.1098 306.163 -19.6113 304.823 -17.7853C303.483 -15.9593 302.574 -13.8533 302.165 -11.6256L302.163 -11.6134L302.161 -11.6012C301.536 -7.6533 299.985 -3.90976 297.633 -0.677738L276.637 26.8434L276.03 27.6387L276.826 28.2452L279.297 30.1287ZM286.509 61.6502L286.518 61.6505L286.527 61.6506C288.133 61.6739 289.723 61.3311 291.176 60.6482L291.176 60.6482L291.185 60.6436C293.588 59.483 295.179 57.5097 296.366 55.2183C297.535 52.9626 298.357 50.3101 299.167 47.6927L299.185 47.6329L299.194 47.6057L299.201 47.578C300.074 44.0601 301.505 40.7049 303.439 37.6397C303.72 37.2426 303.883 36.7731 303.906 36.2865C303.93 35.787 303.808 35.2914 303.553 34.8612C303.298 34.4309 302.922 34.085 302.473 33.8662C302.023 33.6474 301.519 33.5654 301.023 33.6303L301.023 33.6304C300.615 33.684 295.847 34.3386 290.57 36.1725C285.36 37.983 279.333 41.0497 276.793 46.1117L276.793 46.1118C274.831 50.0236 275.241 54.3623 277.767 58.882L277.767 58.8825C278.054 59.3958 278.51 59.7941 279.056 60.0103C281.419 61.0089 283.945 61.5648 286.509 61.6502Z",
    stroke: "#3A2CA0",
    strokeOpacity: 0.08,
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M277.666 75.0136H274.558V73.2093C274.545 68.6475 275.436 64.1283 277.182 59.9136C278.927 55.6988 281.491 51.8722 284.726 48.6553L286.923 50.8527C283.979 53.7819 281.644 57.2661 280.055 61.1036C278.466 64.9412 277.654 69.0558 277.666 73.2093V75.0136Z",
    fill: "#3A2CA0",
    fillOpacity: 0.08
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M277.666 76.0136H278.666V75.0136L278.666 73.2093L278.666 73.2064C278.654 69.1852 279.44 65.2016 280.979 61.4862C282.517 57.7709 284.778 54.3976 287.629 51.5617L288.339 50.8546L287.63 50.1456L285.433 47.9482L284.728 47.243L284.021 47.9462C280.692 51.2564 278.054 55.194 276.258 59.531C274.462 63.8675 273.544 68.5171 273.558 73.2108V75.0136V76.0136H274.558H277.666Z",
    stroke: "#3A2CA0",
    strokeOpacity: 0.08,
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M275.421 66.894C272.313 59.7345 266.506 59.102 266.262 59.0787L266.527 55.9814C266.846 56.0094 274.391 56.7305 278.271 65.6539L275.421 66.894Z",
    fill: "#3A2CA0",
    fillOpacity: 0.08
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M274.504 67.2922L274.903 68.2103L275.82 67.811L278.67 66.5708L279.587 66.1719L279.188 65.2551C275.091 55.8315 267.077 55.0258 266.615 54.9853L265.617 54.8976L265.531 55.896L265.265 58.9932L265.181 59.9799L266.167 60.0741C266.241 60.0813 271.604 60.6129 274.504 67.2922Z",
    stroke: "#3A2CA0",
    strokeOpacity: 0.08,
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M265.679 64.1585C265.014 64.1603 264.352 64.0714 263.712 63.8944C259.87 62.8267 257.997 58.8779 256.345 55.3937C255.708 53.7634 254.811 52.2469 253.69 50.9025C253.466 50.6969 253.308 50.4304 253.235 50.136C253.161 49.8416 253.176 49.5321 253.276 49.2458C253.376 48.9594 253.558 48.7086 253.799 48.5244C254.04 48.3402 254.33 48.2307 254.633 48.2093C260.77 47.7648 272.686 49.6608 273.773 59.944C273.802 60.2265 273.754 60.5118 273.633 60.7688C273.512 61.0258 273.323 61.2447 273.086 61.4017C270.939 63.0232 268.364 63.9815 265.679 64.1585ZM257.786 51.3236C258.26 52.1752 258.701 53.1077 259.154 54.0619C260.588 57.0845 262.071 60.2112 264.545 60.8997C266.089 61.3255 268.105 60.8033 270.539 59.3379C269.233 52.9367 261.963 51.5723 257.786 51.3236Z",
    fill: "#3A2CA0",
    fillOpacity: 0.08
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M265.682 65.1585L265.713 65.1585L265.745 65.1564C268.615 64.9671 271.368 63.9452 273.666 62.2162C274.042 61.9597 274.343 61.6072 274.537 61.1951L273.633 60.7688L274.537 61.195C274.737 60.7727 274.816 60.3038 274.767 59.8395L274.767 59.8389C274.176 54.2393 270.604 50.9401 266.499 49.1381C262.429 47.3518 257.744 46.9815 254.562 47.2118C254.064 47.2472 253.588 47.4272 253.192 47.7297C252.796 48.0324 252.497 48.4445 252.332 48.9152C252.167 49.3859 252.144 49.8945 252.265 50.3783C252.379 50.838 252.62 51.2561 252.958 51.5865C253.993 52.8374 254.822 54.2456 255.414 55.758L255.427 55.7905L255.442 55.8221L255.462 55.8639C256.274 57.578 257.191 59.5106 258.404 61.1462C259.639 62.8103 261.237 64.2445 263.444 64.8578L263.445 64.8582C264.174 65.0595 264.926 65.1606 265.682 65.1585ZM260.057 53.6331L260.039 53.5954C259.865 53.2268 259.689 52.856 259.51 52.4885C261.206 52.7068 263.112 53.1312 264.815 53.9291C266.931 54.9204 268.669 56.4496 269.386 58.8475C267.348 59.9629 265.845 60.2204 264.812 59.936C263.908 59.6842 263.09 58.9587 262.282 57.7883C261.478 56.6219 260.783 55.163 260.057 53.6331Z",
    stroke: "#3A2CA0",
    strokeOpacity: 0.08,
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_19491_33012",
    x1: 0,
    y1: 0,
    x2: 281.805,
    y2: 184.129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.223958,
    stopColor: "#A9E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.916946,
    stopColor: "#D3EDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_19491_33012",
    x1: 1,
    y1: 4.35,
    x2: 285.956,
    y2: 203.682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#33CBFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33CBFE",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_19491_33012",
    x1: 120.029,
    y1: 61.0588,
    x2: -38.1177,
    y2: -6.00001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73C0EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73C0EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_19491_33012",
    x1: 109.5,
    y1: 54,
    x2: -32,
    y2: -6.00001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73C0EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73C0EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_19491_33012",
    x1: 100.725,
    y1: 48.1176,
    x2: -26.902,
    y2: -6.00001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73C0EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73C0EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_19491_33012",
    x1: 91.951,
    y1: 42.2353,
    x2: -21.8039,
    y2: -6.00001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73C0EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73C0EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_19491_33012",
    x1: 82.299,
    y1: 35.7647,
    x2: -16.1961,
    y2: -6.00001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73C0EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73C0EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_19491_33012",
    x1: 73.5245,
    y1: 29.8823,
    x2: -11.098,
    y2: -6.00001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73C0EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73C0EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_19491_33012",
    x1: 64.75,
    y1: 24,
    x2: -6,
    y2: -6.00001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73C0EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73C0EF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19491_33012"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 335,
    height: 74,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAyurvedaBg);
export default __webpack_public_path__ + "static/media/Ayurveda-Bg.5cae5e344cf46655983b27e4aa4535d1.svg";
export { ForwardRef as ReactComponent };